// extracted by mini-css-extract-plugin
export default {"checkboxSection":"WdAeYRTeXaAcfFLglOCw"};